import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiAxios from 'helpers/apiAxios';
import { toast } from 'react-toastify';

const BASE = (projectId) => `/crm/projects/${projectId}/shipments`;

export const getProjectShipments = createAsyncThunk(
  'ProjectShipment/getProjectShipments',
  async ({ projectId, params }, { rejectWithValue }) => {
    try {
      const response = await apiAxios.get(BASE(projectId), { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const projectShipmentSlice = createSlice({
  name: 'project_shipment',
  initialState: {
  buildingTotals: [],
  projectTotal: null,
    data:       [],
    totalRows:  0,
    totalPages: 0,
    page:       1,
    perPage:    20,
    loading:    false,
    params:     {},
  },
  reducers: {
    setShipmentPage:    (state, action) => { state.page    = action.payload; },
    setShipmentPerPage: (state, action) => { state.perPage = action.payload; state.page = 1; },
    setShipmentParams:  (state, action) => { state.params  = action.payload; state.page = 1; },
    resetShipmentParams:(state)         => { state.params  = {}; state.page = 1; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProjectShipments.pending, (state) => { state.loading = true; })
      .addCase(getProjectShipments.fulfilled, (state, action) => {
        state.loading   = false;
        state.data      = action.payload.rows      ?? [];
        // Per-building BOM vs shipped, computed over every shipment of the
        // building rather than the page — see WeightSummaryQuery#by_building.
        state.buildingTotals = action.payload.building_totals ?? [];
        state.projectTotal = action.payload.project_total ?? null;
        state.totalRows = action.payload.total_rows ?? 0;
        state.totalPages= action.payload.total_pages ?? 0;
      })
      .addCase(getProjectShipments.rejected, (state, action) => {
        state.loading = false;
        toast.error(action.payload?.error || action.error.message);
      });
  },
});

export const {
  setShipmentPage,
  setShipmentPerPage,
  setShipmentParams,
  resetShipmentParams,
} = projectShipmentSlice.actions;

export default projectShipmentSlice.reducer;
